export default __webpack_public_path__ + "static/media/logo-dark.af75c325.webp";